import HistoryLayout from '@/routes/account/layout/HistoryLayout';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

interface TicketsProps {}

const Tickets: FC<TicketsProps> = () => {
  return (
    <HistoryLayout bookingType="tickets">
      <Outlet />
    </HistoryLayout>
  );
};

export default Tickets;
